module.exports = __webpack_public_path__ + "static/media/performance-tracking.0251b81a.svg";